import React from 'react';
import styles from './ProfileUsername.module.scss';
export const ProfileUsername = ({ username, hasProfile, onUsernameClick })=>{
    if (!hasProfile) return /*#__PURE__*/ React.createElement("span", null, username);
    const handleClick = (event)=>{
        event.stopPropagation();
        onUsernameClick(username);
    };
    return /*#__PURE__*/ React.createElement("span", {
        className: styles.usernameLink,
        tabIndex: 0,
        onClick: handleClick
    }, username);
};
